import { render, staticRenderFns } from "./CostUserDraggable.vue?vue&type=template&id=4dfcfbe8&scoped=true&"
import script from "./CostUserDraggable.vue?vue&type=script&lang=js&"
export * from "./CostUserDraggable.vue?vue&type=script&lang=js&"
import style0 from "./CostUserDraggable.vue?vue&type=style&index=0&id=4dfcfbe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfcfbe8",
  null
  
)

export default component.exports